document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-geo-region-change]').forEach(el => {
        el.addEventListener('click', function (e) {
            e.preventDefault()
            const regionId = this.dataset.id
            const officeCode = this.dataset.office
            const regionName = this.dataset.name
            const request = BX.ajax.runComponentAction('utlab:geo', 'change', {
                method: 'POST',
                mode: 'class',
                data: {
                    regionId,
                    regionName,
                    officeCode,
                    SITE_ID: 's1',
                    sessid: BX.message('bitrix_sessid')
                }
            });
            request.then(function (response) {
                if (response.errors.length === 0) {
                    location.href = '/';
                }
            })
        })
    })
    if (document.querySelectorAll('[name="geo-search"]').length > 0) {
        document.querySelector('[name="geo-search"]').addEventListener('keyup', function () {
            const currentValue = this.value;
            if (currentValue !== '') {
                document.querySelectorAll('.popup-geo__item').forEach(function (section) {
                    section.classList.remove('hide');

                    let countMatch = 0;

                    section.querySelectorAll('li').forEach(function (item) {
                        item.classList.remove('hide');

                        if (!item.dataset.name.match(new RegExp('^' + currentValue, 'gi'))) {
                            item.classList.add('hide');
                        } else {
                            countMatch++;
                        }
                    });
                    if (countMatch === 0) {
                        section.classList.add('hide');
                    }
                });
            } else {
                document.querySelectorAll('.popup-geo__item').forEach(function (section) {
                    section.classList.remove('hide');
                    section.querySelectorAll('li').forEach(function (item) {
                        item.classList.remove('hide')
                    });
                });
            }
        });
    }
})